import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import {
    ICreateFestivalBonusGrantRequest,
    IFestivalBonusGrant,
    IFestivalBonusPreview,
} from '../interfaces/payroll.interface';

// Festival bonus grant lifecycle (spec §2.1). Grant create/list are institution-scoped; preview
// and delete are keyed off the grant id alone (the backend resolves institutionId off the loaded
// grant for its own tenancy check).
export const FestivalBonusService = {
    createGrant: async (
        data: ICreateFestivalBonusGrantRequest,
        institutionId?: string
    ): Promise<IFestivalBonusGrant> => {
        const instId = institutionId || AuthService.getSelectedInstitution()!!;
        const response = await axios.post(ENDPOINTS.FESTIVAL_BONUS.BASE(instId), data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    listGrants: async (year: number, institutionId?: string): Promise<IFestivalBonusGrant[]> => {
        const instId = institutionId || AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.FESTIVAL_BONUS.LIST(instId, year), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    previewGrant: async (grantId: string): Promise<IFestivalBonusPreview> => {
        const response = await axios.get(ENDPOINTS.FESTIVAL_BONUS.PREVIEW(grantId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    deleteGrant: async (grantId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.FESTIVAL_BONUS.DELETE(grantId), {
            headers: AuthService.getAuthHeader(),
        });
    },

    voidGrant: async (grantId: string, reason: string, institutionId?: string): Promise<void> => {
        const instId = institutionId || AuthService.getSelectedInstitution()!!;
        await axios.post(ENDPOINTS.FESTIVAL_BONUS.VOID(instId, grantId), { reason }, {
            headers: AuthService.getAuthHeader(),
        });
    },
};
